import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import "./style.scss";

const HomePage: FC<{ className?: string; children?: JSX.Element }> = (
  props
) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/upload`);

    // eslint-disable-next-line
  }, []);

  return (
    <section className={`HomePage ${props.className || ""}`}>
      <Header />

      <section className="home-page-body">{props.children}</section>

      <Footer />
    </section>
  );
};

export default HomePage;
